import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ListingCard } from '../components/ListingCard';
import { favouritesApi } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { Heart, Loader2 } from 'lucide-react';

export default function FavouritesPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    fetchFavourites();
  }, [isAuthenticated, navigate]);

  const fetchFavourites = async () => {
    try {
      const { data } = await favouritesApi.getAll();
      setListings(data);
    } catch (err) {
      console.error('Failed to fetch favourites:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen py-8" data-testid="favourites-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 
            className="text-3xl font-bold flex items-center gap-3"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            <Heart className="h-7 w-7 text-[#E53935]" />
            Saved Listings
          </h1>
          <p className="text-muted-foreground mt-1">
            Listings you've saved for later
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : listings.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {listings.map((listing) => (
              <ListingCard key={listing.id} listing={listing} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <Heart className="h-12 w-12 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 mb-2">No saved listings yet</p>
            <p className="text-sm text-gray-400 mb-6">
              Tap the heart icon on any listing to save it here
            </p>
            <Button onClick={() => navigate('/browse')} className="bg-primary hover:bg-[#097549]">
              Browse Listings
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
